module.exports = __webpack_public_path__ + "img/ie.a5b1f8d9.svg";